var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import TreeNode from './TreeNode';
import { getTreeNodeProps } from './utils/treeUtil';
import { useInjectTreeContext } from './contextTypes';
import { computed, nextTick, defineComponent, onBeforeUnmount, onMounted, ref, shallowRef, Transition, watch, } from 'vue';
import { treeNodeProps } from './props';
import { collapseMotion } from '../_util/transition';
export default defineComponent({
    name: 'MotionTreeNode',
    inheritAttrs: false,
    props: Object.assign(Object.assign({}, treeNodeProps), { active: Boolean, motion: Object, motionNodes: { type: Array }, onMotionStart: Function, onMotionEnd: Function, motionType: String, treeNodeRequiredProps: { type: Object } }),
    slots: ['title', 'icon', 'switcherIcon', 'checkable'],
    setup(props, { attrs, slots }) {
        const visible = ref(true);
        const context = useInjectTreeContext();
        const motionedRef = ref(false);
        const transitionClass = ref('');
        const transitionStyle = shallowRef({});
        const transitionProps = computed(() => {
            if (props.motion) {
                return props.motion;
            }
            else {
                return collapseMotion(transitionStyle, transitionClass);
            }
        });
        const onMotionEnd = (type) => {
            var _a, _b, _c, _d;
            if (type === 'appear') {
                (_b = (_a = transitionProps.value) === null || _a === void 0 ? void 0 : _a.onAfterAppear) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            else if (type === 'leave') {
                (_d = (_c = transitionProps.value) === null || _c === void 0 ? void 0 : _c.onAfterLeave) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            if (!motionedRef.value) {
                props.onMotionEnd();
            }
            motionedRef.value = true;
        };
        watch(() => props.motionNodes, () => {
            if (props.motionNodes && props.motionType === 'hide' && visible.value) {
                nextTick(() => {
                    visible.value = false;
                });
            }
        }, { immediate: true, flush: 'post' });
        onMounted(() => {
            props.motionNodes && props.onMotionStart();
        });
        onBeforeUnmount(() => {
            props.motionNodes && onMotionEnd();
        });
        return () => {
            const { motion, motionNodes, motionType, active, treeNodeRequiredProps } = props, otherProps = __rest(props, ["motion", "motionNodes", "motionType", "active", "treeNodeRequiredProps"]);
            if (motionNodes) {
                return (<Transition {...transitionProps.value} appear={motionType === 'show'} onAfterAppear={() => onMotionEnd('appear')} onAfterLeave={() => onMotionEnd('leave')}>
            <div v-show={visible.value} class={[`${context.value.prefixCls}-treenode-motion`, transitionClass.value]} style={transitionStyle.value}>
              {motionNodes.map((treeNode) => {
                        const restProps = __rest(treeNode.data, []), { title, key, isStart, isEnd } = treeNode;
                        delete restProps.children;
                        const treeNodeProps = getTreeNodeProps(key, treeNodeRequiredProps);
                        return (<TreeNode v-slots={slots} {...restProps} {...treeNodeProps} title={title} active={active} data={treeNode.data} key={key} isStart={isStart} isEnd={isEnd}/>);
                    })}
            </div>
          </Transition>);
            }
            return (<TreeNode v-slots={slots} domRef={ref} class={attrs.class} style={attrs.style} {...otherProps} active={active}/>);
        };
    },
});
